module.exports = __webpack_public_path__ + "static/media/vanderbilt.fa4df2af.png";